import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Custom Components
import ModelTable from "UI/Table/ModelTable";
import TableCard from "UI/Table/TableCard";
import TableCardContent from "UI/Table/TableCardContent";
import DialogContext from "UI/DialogContext/DialogContext";
import LoaderContext from "Components/LoaderContext/LoaderContext";
import model from "Models/poslovniSubjekti";
import dataController from "Lib/dataController";
import PoslovniSubjektDialog from "Views/Administration/PoslovniSubjekti/PoslovniSubjektDialog";
import withRedirect from "Components/withRedirect";
import SnackbarContext from "UI/SnackbarContext/SnackbarContext";

function FinancijeTable(props) {
  const dialogContext = useContext(DialogContext);
  const loaderContext = useContext(LoaderContext);
  const snackbarContext = useContext(SnackbarContext);
  const { t } = useTranslation();

  const [records, setRecords] = useState([]);

  const { redirect } = props;

  const dc = new dataController(model, "admin/financije");

  useEffect(() => {
    refreshRecords();
  }, []);

  const handleDialogClose = (result) => {
    if (result.id) {
      redirect(`/admin/financije/${result.id}`);
    } else if (result.dataChanged) {
      refreshRecords();
    }
  };

  const refreshRecords = () => {
    loaderContext.toggleLoading(true);
    dc.GetData()
      .then((resp) => {
        if (resp.success) {
          setRecords(resp.data);
        }
      })
      .catch((result) => {
        snackbarContext.showNotification(result.error, "error");
      })
      .finally(() => {
        loaderContext.toggleLoading(false);
      });
  };

  const handleRowAction = function(action, id) {
    if (action === "view") {
      redirect(`/admin/financije/${id}`);
    }
  };

  const allowRowAction = function(action, id) {
    return true;
  };


  return (
    <TableCard>
      <TableCardContent>
        <ModelTable
          title={t("titles.financije")}
          viewName="financije"
          records={records}
          dc={dc}
          allowSelection="none"
          allowFilter={true}
          allowExport={true}
          allowAdd={false}
          onRowAction={handleRowAction}
          allowRowAction={allowRowAction}
          onDoubleClick={(id) => handleRowAction("view", id)}
          handleRefresh={refreshRecords}
        />
      </TableCardContent>
    </TableCard>
  );
}

export default withRedirect(FinancijeTable);
